import {
  type ButtonHTMLAttributes,
  type FC,
  type ReactNode,
  useCallback,
} from 'react';
import { twMerge } from 'tailwind-merge';

import { GLOBAL_TOOLTIP } from '@/constants/constants';

interface Props extends ButtonHTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

export const DivButton: FC<Props> = ({
  onClick = () => {},
  onKeyDown = () => {},
  tabIndex = 0,
  className = '',
  children = undefined,
  disabled,
  ...otherProps
}) => {
  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      if (disabled) return;
      onClick(e);
    },
    [disabled, onClick]
  );

  return (
    <div
      className={twMerge(className, disabled && 'opacity-30')}
      data-tooltip-delay-show={300}
      data-tooltip-id={GLOBAL_TOOLTIP}
      role="button"
      tabIndex={tabIndex}
      onClick={handleClick}
      onKeyDown={onKeyDown}
      {...otherProps}
    >
      {children}
    </div>
  );
};
